import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    socket : {},
    socketIO:null,
    mySocketId:null,
    proctorRoom:'1234',
    connectionStatus:0,
    candidateInfo:null,
    screenShared:false,
    streamId:null,
    proctoringType:'',
    screenTrack:null,
    webCamTrack:null,
    profileImg:null,
    profileVerified:true,
    activityTrack:null,
    deviceDetail:null,
    reinviteStatus: null,
    interviewInProcess:false,
    streamReceived:false,
    proctoringFlags:[],
    camAccess:false,
    multiMonitor:false,
    loadModel: false,
    questionDurations: {},
    netWorkSpeed: null,
    selectedCameraName: null,
    selectedMicrophoneName: null,
    showMultipleSessionExit: false
};

const socketSlice = createSlice({
    name:'socket',
    initialState,
    reducers : {
        setProctorRoom : (state, {payload}) => {
            state.proctorRoom = payload;
        },
        setMySocketId : (state, {payload}) => {
            state.mySocketId = payload;
        },
        setConnectionStatus : (state, {payload}) => {
            state.connectionStatus = payload;
        },
        setSocketIO : (state, {payload})=> {
            state.socketIO = payload;
        },
        setCandidateInfo : (state, {payload})=> {
            state.candidateInfo = payload;
        },
        setScreenShared : (state, {payload})=> {
            state.screenShared = payload;
        },
        setStreamId : (state, {payload})=> {
            state.streamId = payload;
        },
        setProctoringType : (state, {payload})=> {
            state.proctoringType = payload;
        },
        setScreenTrack :(state,{payload})=>{
            state.screenTrack = payload;
        },
        setWebCamTrack :(state,{payload})=>{
            state.webCamTrack = payload;
        },
        setProfileImg :(state,{payload})=>{
            state.profileImg = payload;
        },
        setProfileVerified :(state,{payload})=>{
            state.profileVerified = payload;
        },
        setProctoringTrack:(state,{payload})=>{
            state.activityTrack=payload;
        },
        setDeviceDetail:(state,{payload})=>{
            state.deviceDetail=payload;
        }, 
        setReinviteStatus :(state,{payload})=>{
            state.reinviteStatus=payload
        },
        setInterviewInProcess :(state,{payload})=>{
            state.interviewInProcess=payload
        },
        setStreamReceived :(state,{payload})=>{
            state.streamReceived=payload
        },
        setProctoringFlags : (state, {payload})=>{
            state.proctoringFlags= payload
        },
        setCamAccess : (state, {payload})=>{
            state.camAccess= payload
        },
        setMultiMonitor:(state,{payload} ) =>{
            state.multiMonitor =payload
        },
        setLoadModel:(state,{payload} ) =>{
            state.loadModel =payload
        },
        setQuestionDurations:(state,{payload})=>{
            state.questionDurations = payload;
        },
        setNetWorkSpeed:(state,{payload})=>{
            state.netWorkSpeed = payload;   
        },
        setSelectedCameraName:(state,{payload})=>{
            state.selectedCameraName = payload;
        },
        setSelectedMicrophoneName:(state,{payload})=>{
            state.selectedMicrophoneName = payload;
        }, 
        setShowMultipleSessionExit : (state, {payload}) => {
            state.showMultipleSessionExit = payload
        }
    }
})

export const {setProctorRoom,setProctoringTrack ,setMySocketId, setConnectionStatus, setSocketIO, setCandidateInfo, setScreenShared, setStreamId, setProctoringType, setScreenTrack, setWebCamTrack, setProfileImg, setProfileVerified, setDeviceDetail,setReinviteStatus,setInterviewInProcess, setStreamReceived, setProctoringFlags, setCamAccess,setMultiMonitor, setLoadModel,setQuestionDurations, setNetWorkSpeed, setSelectedCameraName, setSelectedMicrophoneName, setShowMultipleSessionExit} = socketSlice.actions;

export const getProctorRoom = (state) => state.socket.proctorRoom;
export const getMySocketId = (state) => state.socket.mySocketId;
export const getConnectionStatus = (state) => state.socket.connectionStatus;
export const getSocketIO = (state) => state.socket.socketIO;
export const getCandidateInfo = (state) => state.socket.candidateInfo;
export const getScreenShared = (state) => state.socket.screenShared;
export const getStreamId = (state) => state.socket.streamId;
export const getProctoringType = (state) => state.socket.proctoringType;
export const getScreenTrack = (state) => state.socket.screenTrack;
export const getWebCamTrack = (state) => state.socket.webCamTrack;
export const getProfileImg = (state) => state.socket.profileImg;
export const getProfileVerified = (state) => state.socket.profileVerified;
export const getProctoringTrack=(state)=>state.socket.activityTrack;
export const getDeviceDetail=(state)=>state.socket.deviceDetail;
export const getReinviteStatus =(state)=>state.socket.reinviteStatus;
export const getInterviewInProcess =(state)=>state.socket.interviewInProcess;
export const getStreamReceived =(state)=>state.socket.streamReceived;
export const getProctoringFlags = (state)=>state.socket.proctoringFlags;
export const getCamAccess = (state)=>state.socket.camAccess;
export const getMultiMonitor =(state)=>state.socket.multiMonitor;
export const getLoadModel = (state)=>state.socket.loadModel;
export const getQuestionDurations = (state) => state.socket.questionDurations;
export const getNetWorkSpeed = (state) => state.socket.netWorkSpeed;
export const getSelectedCameraName = (state) => state.socket.selectedCameraName;
export const getSelectedMicrophoneName = (state) => state.socket.selectedMicrophoneName;
export const getShowMultipleSessionExit = (state) => state.socket.showMultipleSessionExit

export default socketSlice.reducer;